import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { useMutation, useQueryCache } from 'react-query'
import { postBusiness } from '../../../../Api/index'
import ExpandedRecordsBusiness from '../../ExpandedRecords/ExpandedRecordBusiness'
import useStore from '../../BusinessStore/Store'
import expandedRecordIcon from '../../images/expandedSVG.svg'

function Results () {
  const { dataResults, isQueryLoading } = useStore()
  const dataRecords = dataResults?.data?.records

  // State to manage modal visibility and record data
  const [isModalOpen, setModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [errorNotEnoughCredits, setErrorNotEnoughCredits] = useState(false)
  const [snackBarStateError, setSnackBarStateError] = useState(false)
  const [isLoadingRecord, setLoadingRecord] = useState(false)
  const queryCache = useQueryCache()

  // Mutation to fetch record details if not in cache
  const [mutate] = useMutation(postBusiness, {
    onSuccess: data => {
      const newRecord = data?.data?.records[0]
      if (newRecord) {
        const cacheKey = `recordByID-${newRecord.keys[0]}`
        queryCache.setQueryData(cacheKey, newRecord)
        setSelectedRecord(newRecord)
        setModalOpen(true)
        setLoadingRecord(false)
      }
    },

    onError: () => {
      setSnackBarStateError(true)
      setTimeout(() => {
        setErrorNotEnoughCredits(true)
        setLoadingRecord(false)
      }, 1000)
    }
  })

  // Handle clicking on a record: check cache or fetch new data
  const handleRecordClick = record => {
    const cacheKey = `recordByID-${record.keys[0]}`
    const cachedData = queryCache.getQueryData(cacheKey)

    setModalOpen(true)
    setSelectedRecord(cachedData || null)
    setLoadingRecord(!cachedData)

    if (!cachedData && !isQueryLoading) {
      mutate({ query: `keys:"${record?.keys[0]}"` })
    } else if (cachedData) {
      setLoadingRecord(false)
    }
  }

  // Clean up any cached queries starting with "recordByID"
  useEffect(() => {
    if (queryCache) {
      queryCache.getQueries().forEach(query => {
        if (
          typeof query?.queryKey[0] === 'string' &&
          query.queryKey[0].startsWith('recordByID')
        ) {
          queryCache.removeQueries(query.queryKey)
        }
      })
    }
  }, [dataResults, queryCache])

  return (
    <section className={styles.searchResultsContainerWithScroll}>
      {dataRecords?.map((record, index) => (
        <div
          onClick={() => handleRecordClick(record)}
          key={index}
          className={styles.searchResultsContainer}
          style={{
            opacity: isQueryLoading ? 0.5 : 1,
            cursor: isQueryLoading ? 'not-allowed' : 'pointer'
          }}
        >
          <div className={styles.expandedRecordPeopleContainer}>
            <div className={styles.expandedRecordPeopleName}>
              <span className={styles.expandedRecordPeopleNameText}>
                {record.name ? record.name : 'N/A'}
              </span>
            </div>
            <div>
              <img
                className={styles.expandedRecordPeopleIcon}
                src={expandedRecordIcon}
                alt='ExpandIcon'
              />
            </div>
          </div>

          <div className={styles.expandedRecordPeopleDetails}>
            <div className={styles.listingItem} style={{ width: '115px' }}>
              <span className={styles.expandedRecordPeopleDetail}>Address</span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.address ? record.address : 'N/A'}
              </span>
            </div>

            <div className={styles.listingItem} style={{ width: '115px' }}>
              <span className={styles.expandedRecordPeopleDetail}>City</span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.city ? record.city : 'N/A'}
              </span>
            </div>

            <div className={styles.listingItem} style={{ width: '115px' }}>
              <span className={styles.expandedRecordPeopleDetail}>
                State/Province
              </span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.province ? record.province : 'N/A'}
              </span>
            </div>

            <div className={styles.listingItem} style={{ width: '115px' }}>
              <span className={styles.expandedRecordPeopleDetail}>
                Postal Code
              </span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.postalCode ? record.postalCode : 'N/A'}
              </span>
            </div>

            <div className={styles.listingItem} style={{ width: '115px' }}>
              <span className={styles.expandedRecordPeopleDetail}>
                Categories
              </span>
              <span className={styles.expandedRecordPeopleValue}>
                {Array.isArray(record.categories) &&
                record.categories.length > 0
                  ? record.categories.slice(0, 3).join(', ')
                  : 'N/A'}
              </span>
            </div>

            <div className={styles.listingItem} style={{ width: '115px' }}>
              <span className={styles.expandedRecordPeopleDetail}>Website</span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.websites ? record.websites[0] : 'N/A'}
              </span>
            </div>

            <div className={styles.listingItem} style={{ width: '115px' }}>
              <span className={styles.expandedRecordPeopleDetail}>Reviews</span>
              <span className={styles.expandedRecordPeopleValue}>
                {record.reviews ? `${record.reviews.length} available` : 'N/A'}
              </span>
            </div>

            <div
              className={styles.listingItem}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <span className={styles.expandedRecordPeopleFieldsAvailable}>
                {dataResults?.data?.records?.length} fields available
              </span>
            </div>
          </div>
        </div>
      ))}

      {isModalOpen && (
        <ExpandedRecordsBusiness
          recordData={selectedRecord}
          isLoadingRecord={isLoadingRecord}
          errorNotEnoughCredits={errorNotEnoughCredits}
          setErrorNotEnoughCredits={setErrorNotEnoughCredits}
          snackBarStateError={snackBarStateError}
          onClose={() => setModalOpen(false)}
        />
      )}
    </section>
  )
}

export default Results
